import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridGetterFunction,
  GridCountFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetRegisterNumberingDto } from '../../../common/spdCore/autogenerated/spdApiClient';

interface RegisterNumberingProps {
  getData?: GridGetterFunction;
  getDataCount?: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const registerNumberingForGrid = (
  registerNumbering: GetRegisterNumberingDto,
) => {
  return {
    key: registerNumbering.id,
    values: {
      'register.name': registerNumbering.register?.name,
      'registerNumbering.symbolDoctor': registerNumbering.symbolDoctor,
      'registerNumbering.symbolPsychological':
        registerNumbering.symbolPsychological,
      'registerNumbering.activeFrom': registerNumbering.activeFrom
        ? registerNumbering.activeFrom.toLocaleDateString('pl-PL')
        : undefined,
      'registerNumbering.activeTo': registerNumbering.activeTo
        ? registerNumbering.activeTo.toLocaleDateString('pl-PL')
        : undefined,
    },
  };
};

export const RegisterNumbering: React.FC<RegisterNumberingProps> = props => {
  const columns = [
    { header: 'Rejestr', property: 'register.name' },
    { header: 'Symbol Doktor', property: 'registerNumbering.symbolDoctor' },
    {
      header: 'Symbol Psycholog',
      property: 'registerNumbering.symbolPsychological',
    },
    { header: 'Aktywny od', property: 'registerNumbering.activeFrom' },
    { header: 'Aktywny do', property: 'registerNumbering.activeTo' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getDataCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="register.name"
      availablePageSizes={[10, 20, 50]}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
    />
  );
};
